/* Garbage Juice Theme JS */

(function () {
  'use strict';

  // ── CART DRAWER ──
  const drawer    = document.getElementById('cart-drawer');
  const overlay   = drawer && drawer.querySelector('.cart-drawer__overlay');
  const closeBtn  = drawer && drawer.querySelector('.cart-drawer__close');
  const cartToggles = document.querySelectorAll('.js-cart-toggle');

  function openCart()  { drawer && drawer.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
  function closeCart() { drawer && drawer.classList.remove('is-open'); document.body.style.overflow = ''; }

  cartToggles.forEach(btn => btn.addEventListener('click', openCart));
  overlay  && overlay.addEventListener('click', closeCart);
  closeBtn && closeBtn.addEventListener('click', closeCart);

  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeCart(); });

  // ── ADD TO CART (AJAX) ──
  document.addEventListener('submit', async function (e) {
    const form = e.target;
    if (!form.classList.contains('product-form') && !form.querySelector('.js-add-to-cart')) return;

    e.preventDefault();

    const btn = form.querySelector('button[type="submit"], .js-add-to-cart');
    const originalText = btn ? btn.textContent : '';

    if (btn) { btn.textContent = 'Adding…'; btn.disabled = true; }

    try {
      const data = new FormData(form);
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        body: data,
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });

      if (!response.ok) throw new Error('Add to cart failed');

      await refreshCart();
      openCart();
    } catch (err) {
      console.error(err);
    } finally {
      if (btn) { btn.textContent = originalText; btn.disabled = false; }
    }
  });

  // ── REFRESH CART COUNT + DRAWER BODY ──
  async function refreshCart() {
    try {
      const [cartRes, sectionRes] = await Promise.all([
        fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } }),
        fetch('/?sections=cart-drawer-items')  // optional section rendering
      ]);

      const cart = await cartRes.json();

      // Update count badge(s)
      document.querySelectorAll('.js-cart-count').forEach(el => {
        el.textContent = cart.item_count;
      });
    } catch (err) {
      console.error('Cart refresh failed', err);
    }
  }

  // ── PRODUCT PAGE: SIZE SELECTOR ──
  document.querySelectorAll('.option-btn').forEach(btn => {
    btn.addEventListener('click', function () {
      const position = this.dataset.optionPosition;
      const group = document.querySelectorAll(`.option-btn[data-option-position="${position}"]`);
      group.forEach(b => b.classList.remove('is-selected'));
      this.classList.add('is-selected');
      updateVariant();
    });
  });

  function updateVariant() {
    const selected = {};
    document.querySelectorAll('.option-btn.is-selected').forEach(btn => {
      selected[btn.dataset.optionPosition] = btn.dataset.optionValue;
    });

    // Shopify exposes variants via a global — rely on meta tags for the selected variant ID
    // This is a basic implementation; full variant switching needs the product JSON endpoint
    const variantId = getVariantIdFromSelection(selected);
    if (variantId) {
      const input = document.querySelector('input[name="id"]');
      if (input) input.value = variantId;
    }
  }

  function getVariantIdFromSelection(selected) {
    // Requires window.productVariants to be set in the product template
    const variants = window.productVariants || [];
    return variants.find(v =>
      Object.entries(selected).every(([pos, val]) => v.options[parseInt(pos) - 1] === val)
    )?.id;
  }

  // ── PRODUCT PAGE: IMAGE GALLERY ──
  document.querySelectorAll('.product-page__img').forEach((img, i) => {
    img.addEventListener('click', function () {
      document.querySelectorAll('.product-page__img').forEach(el => el.classList.remove('is-active'));
      this.classList.add('is-active');
    });
  });

})();

// ── PRODUCT CARD: IMAGE HOVER + TOUCH CYCLING ──
(function () {
  function initHoverCycling(card) {
    const frames = card.querySelectorAll('.product-img__frame');
    const dots   = card.querySelectorAll('.product-img__dot');
    if (frames.length < 2) return;

    let current = 0;

    function showFrame(index) {
      frames[current].classList.remove('is-active');
      dots[current] && dots[current].classList.remove('is-active');
      current = index;
      frames[current].classList.add('is-active');
      dots[current] && dots[current].classList.add('is-active');
    }

    // ── Desktop: mousemove across card width ──
    card.addEventListener('mousemove', function (e) {
      const rect  = card.getBoundingClientRect();
      const ratio = (e.clientX - rect.left) / rect.width;
      const index = Math.min(frames.length - 1, Math.floor(ratio * frames.length));
      if (index !== current) showFrame(index);
    });

    card.addEventListener('mouseleave', function () {
      showFrame(0);
    });

    // ── Mobile: swipe left/right to cycle ──
    let touchStartX = null;
    let touchStartY = null;
    let isSwiping   = false;
    const SWIPE_THRESHOLD = 25; // px

    card.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      isSwiping   = false;
    }, { passive: true });

    card.addEventListener('touchmove', function (e) {
      if (touchStartX === null) return;
      const dx = e.touches[0].clientX - touchStartX;
      const dy = e.touches[0].clientY - touchStartY;
      // Horizontal swipe dominates — lock it and prevent scroll
      if (!isSwiping && Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 8) {
        isSwiping = true;
      }
      if (isSwiping) e.preventDefault();
    }, { passive: false });

    card.addEventListener('touchend', function (e) {
      if (touchStartX === null) return;
      const diff = e.changedTouches[0].clientX - touchStartX;
      touchStartX = null;
      touchStartY = null;

      if (!isSwiping || Math.abs(diff) < SWIPE_THRESHOLD) {
        isSwiping = false;
        return; // treat as tap — let the link through
      }

      isSwiping = false;
      e.preventDefault();

      if (diff < 0) {
        showFrame((current + 1) % frames.length);       // swipe left → next
      } else {
        showFrame((current - 1 + frames.length) % frames.length); // swipe right → prev
      }
    }, { passive: false });
  }

  function init() {
    document.querySelectorAll('.product-img.js-img-hover').forEach(initHoverCycling);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
